import React from "react";
import Alert from "~/components/makers/Alert";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

const contactUs = (
  <a
    href="mailto:hello@govlaunch.com"
    css={{
      color: palette.innovatorBlue,
    }}
  >
    <FormattedMessage defaultMessage="contact us" id="cZ6IMP" />
  </a>
);
export function FailedToCommitPlanChange() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage
          defaultMessage="Sorry but we weren't able to perform this change at this time. Please try again later or {contactUs} to resolve
        the problem."
          id="r4ZPsX"
          values={{
            contactUs: contactUs,
          }}
        />
      </p>
    </Alert>
  );
}

export function FailedToCancelSubscription() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage
          defaultMessage="Sorry but we weren't able to perform the cancellation at this time. Please try again later or {contactUs} to
        resolve the problem."
          id="9n1LEu"
          values={{
            contactUs: contactUs,
          }}
        />
      </p>
    </Alert>
  );
}

export function NotAVendor() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage
          defaultMessage="You cannot access this page because your session expired or you aren't a Vendor. Try logging in again and if the issue still persists, {contactUs}."
          id="HJo/SY"
          values={{
            contactUs: contactUs,
          }}
        />
      </p>
    </Alert>
  );
}

export function NoPlans() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage
          defaultMessage="We couldn't find any plans. Try again later or {contactUs}."
          id="id0JPH"
          values={{
            contactUs: contactUs,
          }}
        />
      </p>
    </Alert>
  );
}

export function NoCurrentPlan() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage defaultMessage="You aren't subscribed to any plan." id="AQ1jSq" />
      </p>
    </Alert>
  );
}

export function NoSelectedPlanToChange() {
  return (
    <Alert>
      <p
        css={{
          margin: 0,
        }}
      >
        <FormattedMessage
          defaultMessage="Couldn't find the plan you want to change to. You can try again later or {contactUs}."
          id="8enPlT"
          values={{
            contactUs: contactUs,
          }}
        />
      </p>
    </Alert>
  );
}
